/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Returntologin2Inputs */

const en_btn_returntologin2 = /** @type {(inputs: Btn_Returntologin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Return to Log In`)
};

/**
* | output |
* | --- |
* | "Return to Log In" |
*
* @param {Btn_Returntologin2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const btn_returntologin2 = /** @type {((inputs?: Btn_Returntologin2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Returntologin2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_btn_returntologin2(inputs)
});
export { btn_returntologin2 as "btn_returnToLogin" }